module.exports = __webpack_public_path__ + "img/8.b76b8765.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":1062,"height":1448,"variants":[{"file":"img/8-480w.e4c42c430c2a.webp","width":480},{"file":"img/8-960w.46c7a08781ec.webp","width":960},{"file":"img/8-1062w.941d2d815bd7.webp","width":1062}]};
}